import React, { useState } from "react";
import Nascom from "../../Images/Nascom.png";
import ISO1 from "../../Images/ISO 1.png";
import ISO2 from "../../Images/ISO 2.png";

function Footer() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    companyName: "",
    personName: "",
    personEmail: "",
    personNumber: "",
    personPosition: "",
    whatsappContact: false,
    meetingDate: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the meeting date to ensure it's not in the past
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for accurate comparison
    const selectedDate = new Date(formData.meetingDate);

    if (formData.meetingDate && selectedDate < today) {
      alert(
        "The expected meeting date cannot be in the past. Please select a future date."
      );
      return;
    }

    try {
      const response = await fetch("https://criterionscreeners.com/api/user-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        alert(
          "Meeting request submitted successfully! A confirmation email has been sent to your email address."
        );
        setIsFormOpen(false);
        setFormData({
          companyName: "",
          personName: "",
          personEmail: "",
          personNumber: "",
          personPosition: "",
          whatsappContact: false,
          meetingDate: "",
          message: "",
        });
      } else {
        alert("Failed to submit meeting request.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while submitting the request.");
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault(); // Prevents the default link behavior
    setIsOpen(!isOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50 select-none">
      <footer className="bg-white border-t">
        <div className="container mx-auto px-4 py-12">
          <div className="mb-12">
            <div className="mb-12">
              <div className="flex items-center text-red-700 mb-8">
                <svg
                  className="w-9 h-9 mr-1"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 0.5L2 4V10C2 16 6.5 21.5 12 22.5C17.5 21.5 22 16 22 10V4L12 0.5Z"
                    fill="red"
                    transform="scale(1.2)"
                  />
                  <circle cx="14.5" cy="14" r="8" fill="white" />
                  <path
                    d="M11 14L13 16L17 12"
                    stroke="red"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-xl font-bold">CRITERION SCREENERS</span>
              </div>
              <div className="h-1 bg-red-700 w-[300px]"></div>
              <div className="h-[2px] bg-red-700 flex-1"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div>
              <h3 className="text-xl font-bold mb-4">Corporate</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="/privacy-policy"
                    className="hover:text-[#ac0000] transition-colors duration-200"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/Data-Privacy" className="hover:text-[#ac0000]">
                    Data Privacy Principles
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    className="hover:text-[#ac0000]"
                    onClick={handleClick}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
              <div
                className={`transition-all duration-500 ease-in-out ${
                  isOpen
                    ? "opacity-100 max-h-96 translate-y-0"
                    : "opacity-0 max-h-0 -translate-y-4 overflow-hidden"
                }`}
              >
                <p className="mb-2 mt-2">
                  📞 +91 80711 88588 || +91 40452 09581
                </p>
                <a
                  href="mailto:Intouch@criterionscreeners.com"
                  className="cursor-pointer"
                >
                  📧 Email: Intouch@criterionscreeners.com
                </a>

                <p className="mb-2 mt-2">
                  <strong>Corporate Office:</strong>
                  <br />
                  Innovator Building, ITPL, Whitefield Road,
                  <br />
                  Bengaluru, Karnataka - 560066
                </p>
                <p>
                  <strong>Branch Office:</strong>
                  <br />
                  Ardente Office One, Hoodi, Bengaluru,
                  <br />
                  Karnataka - 560048
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">Industrial Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/it-services" className="hover:text-[#ac0000]">
                    IT &ITES
                  </a>
                </li>
                <li>
                  <a
                    href="/manufacturing-services"
                    className="hover:text-[#ac0000]"
                  >
                    Manufacturing/Automobile
                  </a>
                </li>
                <li>
                  <a href="/telecom-services" className="hover:text-[#ac0000]">
                    Telecom
                  </a>
                </li>
                <li>
                  <a href="/health-services" className="hover:text-[#ac0000]">
                    Healthcare
                  </a>
                </li>
                <li>
                  <a
                    href="/ecommerce-services"
                    className="hover:text-[#ac0000]"
                  >
                    E-Commerce
                  </a>
                </li>
                <li>
                  <a href="/banking-services" className="hover:text-[#ac0000]">
                    Banking & Financial
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <div className="mt-8">
                <h3 className="text-xl font-bold mb-4">Follow us on social</h3>
                <div className="flex space-x-4">
                  <a
                    href="https://www.facebook.com/profile.php?id=61576150105402"
                    className="block hover:text-[#C4392A] transition-all duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                  <a
                    href="https://www.instagram.com/verifydigital?utm_source=qr&igsh=aWRiaG10dDUxZDMz"
                    className="block hover:text-[#C4392A] transition-all duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                  <a
                    href="https://x.com/CriterionScrenr?t=f2F_a1apRogglPrnSt6Z4Q&s=08"
                    className="block hover:text-[#C4392A] transition-all duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Twitter
                  </a>
                  <a
                    href="https://www.linkedin.com/company/criterion-screeners/posts/?feedView=all"
                    className="block hover:text-[#C4392A] transition-all duration-300"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Linkedin
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center border-t pt-8 text-sm sm:text-base">
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 md:gap-x-6 lg:gap-x-8 mb-6 md:mb-0 order-1">
              <img src={Nascom} alt="NASSCOM Member" className="h-10 sm:h-12 md:h-14 lg:h-16" />
              <img src={ISO1} alt="ISO 9001 Certified" className="h-10 sm:h-12 md:h-14 lg:h-16" />
              <img src={ISO2} alt="ISO 27001 Certified" className="h-10 sm:h-12 md:h-14 lg:h-16" />
            </div>

            <div className="text-center md:text-left mb-6 md:mb-0 order-2">
              <p className="mb-1">
                📞 <a href="tel:+918071188588" className="hover:text-[#ac0000]">+91 80711 88588</a> || <a href="tel:+914045209581" className="hover:text-[#ac0000]">+91 40452 09581</a>
              </p>
              <a
                href="mailto:Intouch@criterionscreeners.com"
                className="cursor-pointer hover:text-[#ac0000] break-all"
              >
                📧 Email: Intouch@criterionscreeners.com
              </a>
            </div>

            <div className="order-3 w-full md:w-auto">
              <button
                className="w-full md:w-auto bg-[#ac0000] text-white px-5 py-2.5 sm:px-6 sm:py-3 rounded hover:bg-[#8e0000] transition-colors duration-300 text-center"
                onClick={() => setIsFormOpen(true)}
              >
                Request a Meeting →
              </button>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center border-t mt-8 pt-8 text-sm text-gray-600">
            <p>Criterion Screeners Global Pvt Ltd: All Rights Reserved</p>
          </div>
        </div>
      </footer>

      {isFormOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 animate-fade-in">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl transform transition-all duration-300 scale-95 hover:scale-100 overflow-y-auto max-h-[90vh]">
            <div className="bg-[#ac0000] text-white p-4 rounded-t-xl flex justify-between items-center sticky top-0 z-10">
              <div className="flex flex-col">
                <h2 className="text-lg sm:text-xl font-semibold">
                  Request a Meeting
                </h2>
                <div className="text-sm sm:text-base">
                  Available Business Hours: 9 AM to 6 PM
                </div>
              </div>
              <button
                onClick={() => setIsFormOpen(false)}
                className="text-white hover:text-gray-200 focus:outline-none text-lg"
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Company Name <span className="text-[#ac0000]">*</span>
                  </label>
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Name <span className="text-[#ac0000]">*</span>
                  </label>
                  <input
                    type="text"
                    name="personName"
                    value={formData.personName}
                    onChange={handleInputChange}
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Email <span className="text-[#ac0000]">*</span>
                  </label>
                  <input
                    type="email"
                    name="personEmail"
                    value={formData.personEmail}
                    onChange={handleInputChange}
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Phone Number <span className="text-[#ac0000]">*</span>
                  </label>
                  <input
                    type="tel"
                    name="personNumber"
                    value={formData.personNumber}
                    onChange={handleInputChange}
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                    required
                  />
                </div>
              </div>

              <div className="flex items-center">
                <label className="flex items-center text-sm font-medium text-gray-700">
                  <input
                    type="checkbox"
                    name="whatsappContact"
                    checked={formData.whatsappContact}
                    onChange={handleInputChange}
                    className="bg-white mr-2 h-4 w-4 text-[#ac0000] focus:ring-[#ac0000] border-gray-300 rounded"
                  />
                  Contact me via WhatsApp
                </label>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Position
                  </label>
                  <input
                    type="text"
                    name="personPosition"
                    value={formData.personPosition}
                    onChange={handleInputChange}
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Expected Meeting Date (Optional)
                  </label>
                  <input
                    type="date"
                    name="meetingDate"
                    value={formData.meetingDate}
                    onChange={handleInputChange}
                    min={
                      new Date(new Date().setDate(new Date().getDate() + 1))
                        .toISOString()
                        .split("T")[0]
                    } // Sets min to tomorrow's date
                    className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="bg-white text-black w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ac0000] focus:border-transparent transition-all duration-200 text-sm sm:text-base"
                  rows="4"
                />
              </div>

              <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4">
                <button
                  type="button"
                  onClick={() => setIsFormOpen(false)}
                  className="w-full sm:w-auto px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-[#ac0000] transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-full sm:w-auto px-6 py-2 bg-[#ac0000] text-white rounded-lg hover:bg-[#8e0000] transition-colors duration-200"
                >
                  Submit Request
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out forwards;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default Footer;
